<template>
  <div class="contact margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <h1>{{ $t('admin.upload')}}</h1>
        <router-link to="/admin">
          <img src="../assets/images/back.png" /> {{ $t('admin.back')}}
        </router-link>
      </div>
    </div>
    <div class="row not-margin">
      <div class="col-md-12 info-form-contact margin-between-section">
        <div class="group">
          <input v-model="name" class="input-form" type="text" :placeholder="$t('admin.name')" />
        </div>
        <div class="group">
          <input v-model="lastname" class="input-form" type="text" :placeholder="$t('admin.last_name')" />
        </div>
        <div class="group">
          <div class="dropdown">
            <template class="btn-d">
              <select v-model="role" class="browser-default custom-select btn-d">
                <option selected value="">{{ $t('admin.role')}} *</option>
                <option :value="$t('admin.roleDir')">{{ $t('admin.roleDir')}}</option>
                <option :value="$t('admin.roleVisor')">{{ $t('admin.roleVisor')}}</option>
                <option :value="$t('admin.roleOther')">{{ $t('admin.roleOther')}}</option>
              </select>
            </template>
          </div>
        </div>

        <div class="group">
          <input v-model="team" class="input-form" type="text" :placeholder="$t('admin.team')" />
        </div>
        <div class="group">
          <input v-model="league" class="input-form" type="text" :placeholder="$t('admin.league')" />
        </div>
        <div class="group">
          <input v-model="email" class="input-form" type="email" :placeholder="$t('admin.email')" />
        </div>
        <p class="error" v-if="error != ''" >* {{error}}</p>
        <div class="group">
          <button v-on:click="save" type="btn" class="btn btn-action m-top-margin">{{ $t('admin.sign_up')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Users from "@/components/Users";
import User from '@/parse/models/User';
import { bus } from '../main'

export default {
  name: "contact",
  components: {},
  data() {
    return {
      name: "",
      lastname: "",
      role: "",
      team: "",
      league: "",
      email: "",
      error: "",
      jsonDef: [
        { position: "gk", value: 1 },
        { position: "cb", value: 2 },
        { position: "lb", value: 3 },
        { position: "rb", value: 4 },
        { position: "lwb", value: 5 },
        { position: "rwb", value: 6 },
      ],
      jsonMed: [
        { position: "dm", value: 7 },
        { position: "cm", value: 8 },
        { position: "am", value: 9 },
        { position: "lm", value: 10 },
        { position: "rm", value: 11 },
      ],
      jsonDel: [
        { position: "cf", value: 12 },
        { position: "s", value: 13 },
        { position: "ss", value: 14 },
      ],
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    save(){
    
      if (this.name == ""){
        
        this.error = this.$t('notification.required')
        return
      }
      if (this.role == ""){
        
        this.error = this.$t('notification.required')
        return
      }
      if (this.email == ""){
        
        this.error = this.$t('notification.required')
        return
      }

      this.error = ""

      const params = {
        name: this.name,
        lastName: this.lastname,
        position: this.role,
        team: this.team,
        league: this.league,
        email: this.email
      }

      this.notificationRedirect = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.create_user'),
        redirect: "admin"
      }

      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }

      User.saveUser(params)
      .then((user) => bus.$emit('sampleRedirect', this.notificationRedirect))
      .catch(error => bus.$emit('sample', this.notificationerror))
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.error {
  color: rgb(190, 0, 0);
  margin-top: 2%;
}

.custom-select {
  background: #fff url("../assets/images/arrow_down.png") no-repeat right .75rem center/8px 10px;
  border: 1px solid #000;
  border-radius: 0;
}

.custom-select:focus{
  border-color: #000;
  box-shadow: none
}

.custom-select option {
    font-weight: 123px;
}


.m-top-margin{
  margin-top: 15%;
}

.btn-action{
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
}


ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
  float: left;
}

.container-age {
  display: inline-block;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}

.info p {
  font-size: 18px;
}

.container-info {
  font-family: "plain regular", arial;
}

.container-info h1 {
  font-family: "plain regular", arial;
  float: left;
  font-size: 22px;
}

.container-info a {
  color: #000;
  font-family: "plain regular", arial;
  float: right;
  margin-right: 5px;
}

.container-info a img {
  width: 20px;
}

.not-margin {
  margin: 0;
}

.not-padding {
  padding: 0;
}

.group {
  margin-top: 3.5%;
}

.info-form-contact {
  text-align: left;
  font-size: 13px;
}

.info-form-contact label {
  margin-bottom: 0;
  font-size: 13px;
}

.input-form {
  border: 0;
  border-bottom: 1px solid #000;
  width: 30%;
  padding-bottom: 10px;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  float: right;
}

.dropdown {
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  color: rgb(138, 138, 138);
  font-size: 9px !important;
}

.camp-position {
  position: relative;
  display: inline-block;
}

.container-footer-drop {
  position: relative;
  display: inline-block;
  float: right;
}

.container-footer-drop img {
  display: inline-block;
}

.container-footer-drop p {
  display: inline-block;
  float: right;
}

.instruction-mapa {
  color: #000;
  font-size: 9px !important;
  width: 180px;
  margin-left: 10px;
}





/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {}

/* Larger than tablet */
@media (max-width: 768px) {
  .input-form {
    width: 100%;
    padding-bottom: 10px;
    margin-top: 18px;
  }
  .dropdown{
    margin-top: 18px;
  }
}

/* Larger than phablet */
@media (max-width: 550px) {
  
}

/* Larger than mobile */
@media (max-width: 400px) {}



</style>
